import React from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  LICENCJA_PO_SLUGU,
  PROG_PROCENT,
  arkuszPrzedmiotu,
  przedmiotyLicencji,
  pytanWEgzaminie,
} from '../data/licencje';
import JsonLd from '../seo/JsonLd';
import { breadcrumbJsonLd } from '../seo/siteMeta';
import styles from '../css/modules/Nauka.module.css';

/** Rozdroże trybu nauki: wybór przedmiotu dla danej licencji. */
const StudyHub = () => {
  const { licencja: licencjaSlug } = useParams();
  const licencja = LICENCJA_PO_SLUGU[licencjaSlug];

  if (!licencja) {
    return (
      <div className={styles.wrap}>
        <h1 className={styles.h1}>Nie znamy takiego uprawnienia</h1>
        <Link className={styles.cta} to="/">Wróć na stronę główną</Link>
      </div>
    );
  }

  const przedmioty = przedmiotyLicencji(licencja);

  return (
    <div className={styles.wrap}>
      <JsonLd data={breadcrumbJsonLd([
        { name: 'Strona główna', path: '/' },
        { name: licencja.nazwa, path: licencja.path },
        { name: 'Nauka według przedmiotów', path: `/nauka/${licencja.slug}` },
      ])} />

      <nav className={styles.breadcrumbs}>
        <Link to="/">Strona główna</Link> / <Link to={licencja.path}>{licencja.nazwa}</Link> / Nauka
      </nav>

      <h1 className={styles.h1}>Nauka do {licencja.dopelniacz}</h1>
      <p className={styles.lead}>
        Materiał podzielony na przedmioty egzaminacyjne. W trybie nauki od razu widzisz, czy
        odpowiedź jest poprawna, wraz z wyjaśnieniem i wskazaniem przepisu. Kiedy poczujesz się
        pewnie, sprawdź się pod presją czasu w trybie pojedynku.{' '}
        {licencja.tryb === 'przedmioty'
          ? `Na egzaminie zdajesz ${przedmioty.length} osobnych testów, łącznie ${pytanWEgzaminie(licencja)} pytań, każdy przy progu ${PROG_PROCENT} procent.`
          : `Egzamin to jeden test: ${licencja.arkusz.pytan} pytań w ${licencja.arkusz.minut} minut, próg ${PROG_PROCENT} procent.`}
      </p>

      <div className={styles.kafle}>
        {przedmioty.map(p => {
          const arkusz = arkuszPrzedmiotu(licencja, p.slug);
          return (
            <Link key={p.slug} to={`/nauka/${licencja.slug}/${p.slug}`} className={styles.kafel}>
              {licencja.tryb === 'przedmioty' && arkusz && (
                <span className={styles.kafelUdzial}>
                  {arkusz.pytan} pytań / {arkusz.minut} min na egzaminie
                </span>
              )}
              <span className={styles.kafelNazwa}>{p.nazwa}</span>
              <span className={styles.kafelOpis}>{p.opis}</span>
            </Link>
          );
        })}
      </div>

      <div className={styles.akcje}>
        <Link className={styles.cta} to="/intro">Sprawdź się w pojedynku</Link>
        <Link className={styles.ctaDrugi} to={licencja.path}>Wróć do opisu uprawnienia</Link>
      </div>
    </div>
  );
};

export default StudyHub;
